import { render } from "./RechargeOrderList.vue?vue&type=template&id=2ede85de&scoped=true"
import script from "./RechargeOrderList.vue?vue&type=script&lang=js"
export * from "./RechargeOrderList.vue?vue&type=script&lang=js"

import "./RechargeOrderList.vue?vue&type=style&index=0&id=2ede85de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ede85de"]])

export default __exports__